module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Food/Pizza-f5625b8fa2db340ddc1001403af2c69e.svg";